export interface UserProfile {
    id: number| undefined;
    cabsbanid: string;
    username: string;
    email: string;
    phone: string;
    companyname: string;
    name: string;
    custcorps: string[];
    banList: BAN[];
    accounttype: string;
    isprimary: boolean;
    brnflag: boolean;
    captchatoken: string;
    banlistraw: string | undefined;
}


export class qvals{
    w: string = '';
}

export interface BAN {
    ban: string;
    bills: Bill[] | undefined;
}
interface Bill {

    cdt: string,
    pdfurl: string,
    rqstyp: string | undefined,
    dev: string | undefined,
    systran: string

}
export interface AuthenticatedResponse {
    accessToken: string;
    refreshToken: string;
    expiration: Date;
}
export interface LocalState {
    interval: any;
    isLoading: boolean;
}


export interface AuthorizationCollection {
    authorizationcollection: Map<string, Authorization[]>;
  }
//   export interface Authorization {
//     lan_id: string;
//     access_level: number;
//   }

export interface Authorization {
    internalrole: string;
    adminrole: boolean;
    adminuserrole: boolean;
    ctsuserrole: boolean;
    cssuserrole: boolean;
    cwpretailrole: boolean;
  }

export function SortBAN(props: BAN[]) {
    let sorted = [...props];


    sorted.sort((a: BAN, b: BAN) => {
        if (a.ban === null && b.ban === null) {
            return 0;
        }
        if (a.ban === null) {
            return 1;
        }
        if (a.ban === null) {
            return -1;
        }
        if (a.ban !== null && b.ban !== null) {
            if (a.ban < b.ban) {
                return -1;
            }
            if (a.ban > b.ban) {
                return 1;
            }
        }
        return 0;
    });

    return sorted;
}

export function SortUserProfile(props: any[]) {
    let sorted = [...props];

    sorted.sort((a: UserProfile, b: UserProfile) => {
        if (a.name === null && b.name === null) {
            return 0;
        }
        if (a.name === null) {
            return 1;
        }
        if (a.name === null) {
            return -1;
        }
        if (a.name !== null && b.name !== null) {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
        }
        return 0;
    });

    sorted.sort((a: UserProfile, b: UserProfile) => {
        if (a.username === null && b.username === null) {
            return 0;
        }
        if (a.username === null) {
            return 1;
        }
        if (a.username === null) {
            return -1;
        }
        if (a.username !== null && b.username !== null) {
            if (a.username < b.username) {
                return -1;
            }
            if (a.username > b.username) {
                return 1;
            }
        }
        return 0;
    });
    sorted.sort((a: UserProfile, b: UserProfile) => {
        if (a.companyname === null && b.companyname === null) {
            return 0;
        }
        if (a.companyname === null) {
            return 1;
        }
        if (a.companyname === null) {
            return -1;
        }
        if (a.companyname !== null && b.companyname !== null) {
            if (a.companyname < b.companyname) {
                return -1;
            }
            if (a.companyname > b.companyname) {
                return 1;
            }
        }
        return 0;
    });

    return sorted;
}